import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ROLE_HOME } from "@/constants/roles";

/** Blocks anonymous access; optionally checks role. */
export function ProtectedRoute({ children, allowedRoles }) {
  const { user, status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50" data-testid="route-loading">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-slate-200 border-t-[#101876]" />
      </div>
    );
  }

  if (status !== "authenticated" || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(user.role_code)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

/** Redirects logged-in users to their home dashboard. */
export function RedirectIfAuthed({ children }) {
  const { user, status } = useAuth();
  if (status === "loading") return null;
  if (status === "authenticated" && user) {
    const home = ROLE_HOME[user.role_code] || "/app/learner";
    return <Navigate to={home} replace />;
  }
  return children;
}
